import script from "./OnlineSocialSecurityApplicationStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineSocialSecurityApplicationStatus.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineSocialSecurityApplicationStatus.vue?vue&type=style&index=0&id=6701cd4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6701cd4a"]])

export default __exports__